import moment from 'moment';

export enum ErrorType {
  Date = 'date',
  Range = 'range',
}
export class DateRange {
  public start: Date | null;
  public end: Date | null;
  public isValid: boolean;
  public errorType?: ErrorType | undefined;
  private _allowedNumberOfMonths?: number;
  private _acceptEmptyDates?: boolean;

  constructor(start: Date | null, end: Date | null, allowedNumberOfMonths?: number, acceptEmptyDates?: boolean) {
    this.start = start?.toString() === 'Invalid Date' ? null : start;
    this.end = end?.toString() === 'Invalid Date' ? null : end;
    this._allowedNumberOfMonths = allowedNumberOfMonths;
    this._acceptEmptyDates = acceptEmptyDates !== undefined ? acceptEmptyDates : true;
    const errorType = this.handleErrorType();
    this.isValid = errorType === undefined;
    this.errorType = errorType;
  }

  private handleErrorType(): ErrorType | undefined {
    let error: ErrorType | undefined = undefined;
    if (this.start !== null || this.end !== null) {
      if (this.start === null || isNaN(this.start.getTime()) || this.end === null || isNaN(this.end.getTime())) {
        error = ErrorType.Date;
      }
      if (!error) {
        const diff = Math.abs(moment(this.start).diff(moment(this.end), 'months'));
        if (this._allowedNumberOfMonths && diff > this._allowedNumberOfMonths) {
          error = ErrorType.Range;
        } else if (this._allowedNumberOfMonths && diff === this._allowedNumberOfMonths) {
          const startDate = this.start?.getDate();
          const endDate = this.end?.getDate();
          if (startDate && endDate && endDate > startDate) {
            error = ErrorType.Range;
          }
        } else if (this.start && this.end && this.start > this.end) {
          error = ErrorType.Date;
        }
      }
    } else {
      if (!this._acceptEmptyDates) error = ErrorType.Date;
    }
    return error;
  }
}
